import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'

export default {
  mixins:[loggedInUserMixin],
  props: {
    fundraiserPageId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      LoadingFetchingFundraiserPagePublic: false,
      LoadingFetchingFundraiserPublic: false
    }
  },
  computed: {
    fundraiserPage() {
      return useFundraiserPagePublicStore().getItemById(this.fundraiserPageId)
    },
    fundraiser() {
      if(this.fundraiserPage === null || this.fundraiserPage === undefined) return null
      return useFundraiserPublicStore().getItemById(this.fundraiserPage.fundraiser_id)
    }
  },
  methods: {
    async fetchFundraiserPage() {
      try {
        this.LoadingFetchingFundraiserPagePublic = true
        const fundraiserPage = await useFundraiserPagePublicStore('default').fetchItemById(this.fundraiserPageId)
        if(fundraiserPage) {
          await useFundraiserPublicStore().fetchItemById(fundraiserPage.fundraiser_id)
        }
        this.LoadingFetchingFundraiserPagePublic = false
        document.title = `${this.fundraiserPage.title} - GroupRev`
      } catch (e) {
        console.error(e)
        this.$notify('An error occurred: ' + e.response.data.message, 'error')
        this.LoadingFetchingFundraiserPagePublic = false
      }
    }
  }
}
